export function insertLineBreakCommand() {
  return function(state, dispatch) {
  	const br = state.schema.nodes.hard_break
  	if (dispatch) dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView())
    return true
  }
}
